import React, { useEffect, useState } from 'react';
import { Select } from 'tea-component';
import { EntryProps } from '../interface';

export const FilterPackageEntry = (props: EntryProps) => {
  const { column, onChange, isEn } = props;
  const [selectValue, setSelectValue] = useState(column.column_value?.[0] ?? '');

  useEffect(() => {
    onChange('', [selectValue]);
  }, [selectValue]);

  return (
    <>
      <span className="fs-entry-text-prefix">{isEn ? "connect" : "关联"}</span>
      <Select
        className="fs-entry-string-operation"
        appearance="button"
        value={selectValue}
        options={column.options_all}
        onChange={(value) => {
          setSelectValue(value);
        }}
        placeholder={isEn ? "Please Select" : "请选择"}
      />
    </>
  );
};
